export enum CurrentStatus {
  MEDICO_REGULADOR,
  CONSULTA_UNIFICADA,
  RADIO_OPERADOR,
  QUEBRA_CARENCIA,
  AMPLIACAO_REDE,
  ATENDIMENTO,
  SUPERVISAO_REGULACAO,
  SUPERVISAO_CHAMADOS,
  STATE_SAMU,
  STATE_SAMU_FASE,
  STATE_POLICIA,
  OPERADOR,
  AREA_TRABALHO,
  EQUIPE,
  SUPERVISAO_DESPACHO,
  DESPACHO,
  INCIDENTE,
  DADOS_ATENDIMENTO,
  MEDICO_BV,
  ENFERMEIRO_BV,
  BUSCADOR_VAGA
}



// WEBPACK FOOTER //
// ./src/app/core/current-status.enum.ts